import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Route-level plan guard: if the org's plan lacks `feature`, show the upsell instead of a raw 403.
// Backend stays authoritative — this is purely UX so direct URLs match the locked sidebar entries.
export default function FeatureGuard({ feature }) {
  const { hasFeature } = useAuth();
  if (feature && !hasFeature(feature)) {
    return <Navigate to={`/upgrade?feature=${feature}`} replace />;
  }
  return <Outlet />;
}
